export const FEATURE_FLAG_IS_DEMO = 'isDemo';
export const FEATURE_FLAG_SHOW_BUTTON_BUY = 'showBuy';
